import { render, staticRenderFns } from "./HalfMadeProducts.vue?vue&type=template&id=757e64ea"
import script from "./HalfMadeProducts.vue?vue&type=script&lang=js"
export * from "./HalfMadeProducts.vue?vue&type=script&lang=js"
import style0 from "./HalfMadeProducts.vue?vue&type=style&index=0&id=757e64ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports